import { ArrowUpRight } from "lucide-react";
import { Kicker } from "./bits";
import { T, CLUB_TIERS } from "./content";
import { scrollToId } from "./hooks";

const LEVEL = { I: "PREMIUM", II: "OR", III: "DIAMANT" };

function apply(rank) {
  window.dispatchEvent(new CustomEvent("club-apply", { detail: LEVEL[rank] || "" }));
  scrollToId("contact");
}

function Tier({ t, lang, cta }) {
  const name = lang === "fr" ? t.nameFr : t.nameEn;
  const feats = lang === "fr" ? t.featsFr : t.featsEn;
  const included = lang === "fr" ? t.includedFr : t.includedEn;
  return (
    <article className={`club-card reveal ${t.invert ? "club-card--invert" : ""}`} data-testid={`club-tier-${t.rank}`}>
      {t.badge && <span className="club-badge">{cta.badge}</span>}
      <span className="club-rank">{t.rank}</span>
      <h3 className="club-name">{name}</h3>
      <span className="club-price">{lang === "fr" ? t.priceFr : t.priceEn}</span>
      <span className="club-tagline">{lang === "fr" ? t.taglineFr : t.taglineEn}</span>
      {included && <span className="club-included">{included}</span>}
      <ul className="club-feats">
        {feats.map((f, i) => (
          <li className="club-feat" key={i}>{f}</li>
        ))}
      </ul>
      <button className="club-apply" onClick={() => apply(t.rank)} data-testid={`club-apply-${t.rank}`}>
        {cta.label}
        <ArrowUpRight size={15} strokeWidth={1.4} />
      </button>
    </article>
  );
}

export default function Club({ lang }) {
  const t = T[lang];
  const cta = { label: t.clubCta, badge: t.clubBadge };
  return (
    <section className="section" id="club" data-testid="section-club">
      <div className="container">
        <div className="section-head reveal">
          <Kicker withDash>{t.clubKicker}</Kicker>
          <h2 className="display club-title">
            {t.clubTitle.map((line, li) => (
              <div className="line-mask" key={li}>
                <span>
                  {line.map((seg, si) =>
                    si % 2 === 1 ? <em key={si} className="accent">{seg}</em> : seg
                  )}
                </span>
              </div>
            ))}
          </h2>
          <p className="lead club-lead reveal">{t.clubLead}</p>
        </div>

        <div className="club-grid">
          {CLUB_TIERS.map((tier) => (
            <Tier key={tier.rank} t={tier} lang={lang} cta={cta} />
          ))}
        </div>

        <div className="club-foot reveal">
          <button className="btn btn--solid" onClick={() => scrollToId("contact")} data-testid="club-cta">
            <span>{t.clubCta}</span>
          </button>
          <p className="club-legal">{t.clubLegal}</p>
        </div>
      </div>
    </section>
  );
}
